document.addEventListener('DOMContentLoaded', () => {
    let currentClone = null;
    let outsideClickListener = null;

    // Function to remove any existing clone
    const removeCurrentClone = () => {
        if (currentClone) {
            currentClone.remove();
            currentClone = null;
        }
        
        // Remove the outside click listener when clone is removed
        if (outsideClickListener) {
            document.removeEventListener('click', outsideClickListener);
            outsideClickListener = null;
        }
    };

    // Handle clicks on markers
    document.addEventListener('click', (e) => {
        const marker = e.target.closest('[id^="marker-"]');
        if (!marker) {
            // Only remove if click is not on a marker and not inside an existing clone
            if (currentClone && !currentClone.contains(e.target)) {
                removeCurrentClone();
            }
            return;
        }

        // Get the company ID from the marker
        const companyId = marker.id.replace('marker-', '');
        const companyCard = document.getElementById(`company-${companyId}`);

        if (!companyCard) return;

        // If clicking the same marker that already has an open clone, do nothing
        if (currentClone && currentClone.id === `company-clone-${companyId}`) {
            return;
        }

        // Remove any existing clone
        removeCurrentClone();

        // Clone the company card
        const clone = companyCard.cloneNode(true);
        clone.id = `company-clone-${companyId}`;
        clone.style.position = 'absolute';
        clone.style.zIndex = '1000';
        clone.style.width = '400px'; // Set a fixed width for the clone
        
        // Position the clone near the marker
        const markerRect = marker.getBoundingClientRect();
        const mapContainer = document.querySelector('.map-container');
        const mapRect = mapContainer.getBoundingClientRect();

        // Calculate position relative to map container
        // Always position to the left of the marker as requested
        let left = markerRect.left - mapRect.left - 400;
        let top = markerRect.top - mapRect.top;

        // Ensure the clone stays within the map container
        if (left < 0) {
            left = 0;
        }

        if(left === 0) {
            left = '50%';
            clone.style.transform = 'translateX(-50%)';
        } else {
            left = `${left}px`;
        }

        clone.style.left = left;
        clone.style.top = `${top}px`;

        // Add close functionality
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '×';
        closeBtn.className = 'absolute top-2 right-2 text-2xl font-bold z-50 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40';
        closeBtn.onclick = removeCurrentClone;
        clone.appendChild(closeBtn);

        // Add the clone to the map container
        mapContainer.appendChild(clone);
        currentClone = clone;

        // Set up outside click listener
        outsideClickListener = (event) => {
            if (!clone.contains(event.target) && !marker.contains(event.target)) {
                removeCurrentClone();
            }
        };
        
        // Add the listener with a slight delay to prevent it from triggering immediately
        setTimeout(() => {
            document.addEventListener('click', outsideClickListener);
        }, 10);
    });
});
